import React, { useEffect, useState } from "react";
import { Form, Button, Typography, Flex, Grid, InputNumber, Radio, Select } from "antd";
import { App } from "antd";
import InputField from "../../../components/Input/Input";
import { useForm } from "antd/es/form/Form";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUnitsList,
  fetchBaseUnitsList,
  createOrUpdateUnit,
  deleteUnit
} from "../unitsThunks";
import { setSelectedUnit, setIsEditUnit } from "../unitsSlice";
import { getAccessType } from "../../../lib/functions";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateUnitsForm = () => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const location = useLocation();
  const navigate = useNavigate();
  const [form] = useForm();

  const { isEditUnit, selectedUnit, units, baseUnits } = useSelector(
    (state) => state.units
  );

  const [isMultiUnit, setIsMultiUnit] = useState("no");
  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("item_unit");
    access_type_set(access);
  }, []);

  useEffect(() => {
    dispatch(fetchUnitsList());
    dispatch(fetchBaseUnitsList());
  }, [dispatch]);

  useEffect(() => {
    if (isEditUnit && selectedUnit) {
      form.setFieldsValue(selectedUnit);
      setIsMultiUnit(selectedUnit.is_multi_unit);
    } else {
      form.setFieldsValue({
        is_multi_unit: "no",
        conversion: 1,
      });
      setIsMultiUnit("no");
    }
  }, [isEditUnit, selectedUnit]);

  const handleCancel = () => {
    dispatch(setSelectedUnit(null));
    dispatch(setIsEditUnit(false));
    navigate(-1);
  };

  const handleSave = async (values) => {

    try {
      if (isMultiUnit === "yes" && (!values.base_unit_id || values.conversion < 2)) {
        modal.warning({
          title: "Base Unit and Conversion must be valid for Multi Unit.",
        });
        return;
      }

      await dispatch(
        createOrUpdateUnit({
          ...values,
          action: isEditUnit ? "update" : "create",
          unit_id: selectedUnit?.unit_id || 0,
        })
      ).unwrap();

      modal.success({
        title: isEditUnit ? "Unit updated successfully" : "Unit created successfully",
      });

      dispatch(setSelectedUnit(null));
      dispatch(setIsEditUnit(false));
      navigate("/unit-manage");
    } catch (error) {      
      modal.warning({
        title: error.message || "Save failed",
        content: error.msg
      });
    }
  };

  return (

    <div className="unit-form">
      <Title level={2} style={{ marginBottom: "32px" }}>
        {isEditUnit ? "Update Unit" : "Create New Unit"}
      </Title>

      <Form
        form={form}
        layout="horizontal"
        onFinish={handleSave}
        variant="filled"
        style={{ width: "100%", maxWidth: "1200px" }}
        // className="responsive-form"
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
      >

        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex vertical gap={10} style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}>
            <Form.Item label="Unit Symbol" name="unit_symbol" rules={[{ required: true, message: "Enter unit symbol"}]}>
              <InputField placeholder="Enter Unit Symbol" />
            </Form.Item>

            <Form.Item label="Unit Name" name="unit_name" rules={[{ required: true, message: "Unit Name is required" }]}>
              <InputField placeholder="Enter Unit Name" />
            </Form.Item>

            <Form.Item label="Is Multi Unit" name="is_multi_unit">
              <Radio.Group
                value={isMultiUnit}
                onChange={(e) => {
                  setIsMultiUnit(e.target.value);
                  form.setFieldValue("is_multi_unit", e.target.value);
                  if (e.target.value === "no") {
                    form.setFieldValue("conversion", 1);
                    form.setFieldValue("base_unit_id", null);
                  }
                }}
                options={[
                  { label: "Yes", value: "yes" },
                  { label: "No", value: "no" },
                ]}
              />
            </Form.Item>
            </Flex>
            <Flex
              vertical
              gap={10}
              style={{width: !screens.md || !screens.xl ? "100%" : "40%"}}
            >
            {isMultiUnit === "yes" && (
              <>
                <Form.Item label="Conversion" name="conversion" rules={[{ required: true, message: "Enter conversion value" }]}>
                  <InputNumber min={2} 
                  style={{ width: "100%" }}
                  onWheel={(e) => e.target.blur()} />
                </Form.Item>

                <Form.Item label="Base Unit" name="base_unit_id" rules={[{ required: true, message: "Select a base unit" }]}>
                  <Select
                    placeholder="Select Base Unit"
                    options={baseUnits.map((el) => ({
                      label: el.unit_name,
                      value: el.unit_id,
                    }))}
                  />
                </Form.Item>
              </>
            )}
          </Flex>
        </Flex>

        <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
          <Button size="large" shape="default" onClick={handleCancel} className="traic-button">
            Back
          </Button>
          {access_type == "WRITE" && <>
            <Button type="primary" size="large" htmlType="submit" className="traic-button">
              {isEditUnit ? "Update" : "Save"}
            </Button>
          </>}
        </Flex>
      </Form>
    </div>
  );
};

export default CreateUnitsForm;
